import * as types from './mutation-types'

export default {
  [types.RESET_FORM] (state) {
    state.options = {
      entity: undefined,
      goal: undefined,
      objectives_services: [],
      locations: {
        cities: [],
        countries: []
      },
      duration: undefined,
      features: []
    }
    state.summary = {
      entity: '',
      goal: '',
      objectives_services: [],
      locations: '',
      duration: '',
      audience: {}
    }
    state.hasSelectedObjectivesServices = false
    state.hasSelectedLocations = false
    state.goLocationsClicked = false
    state.goDurationsClicked = false
  },
  [types.OPTION_ENTITY_SELECTED] (state, payload) {
    state.options.entity = payload.entity
    state.options.objectives_services = []
    state.hasSelectedObjectivesServices = false
    if (state.options.goal && state.options.goal.length) {
      if (!state.structure['step2'][payload.entity][state.options.goal]) {
        state.options.goal = ''
        state.options.duration = ''
        state.hasSelectedLocations = false
        state.goLocationsClicked = false
        state.goDurationsClicked = false
      }
    }
  },
  [types.OPTION_GOAL_SELECTED] (state, payload) {
    if (['objectives', 'services'].includes(payload.goal)) {
      state.options.goal = payload.goal
    }
  },
  [types.OPTION_OBJECTIVES_SERVICES_SELECTED] (state, payload) {
    if (state.options.goal !== 'objectives') {
      if (state.options.objectives_services.includes(payload.option.value)) {
        // remove
        state.options.objectives_services.splice(state.options.objectives_services.indexOf(payload.option.value), 1)
        const features = payload.option.features.split(',')
        for (const f of features) {
          state.options.features.splice(state.options.features.indexOf(f), 1)
        }
      } else {
        // add
        state.options.objectives_services.push(payload.option.value)
        const features = payload.option.features.split(',')
        for (const f of features) {
          if (!state.options.features.includes(f)) {
            state.options.features.push(f)
          }
        }
      }
    } else {
      state.options.objectives_services = [payload.option.value]
      const features = payload.option.features.split(',')
      state.options.features = []
      for (const f of features) {
        state.options.features.push(f)
      }
    }
    state.hasSelectedObjectivesServices = state.options.objectives_services.length > 0
  },
  [types.OPTION_DURATION_SELECTED] (state, payload) {
    if (['3_months', '6_months', '9_months', '12_months'].includes(payload.duration)) {
      state.options.duration = payload.duration
    }
  },
  [types.STRUCTURE_CHANGED] (state, structure) {
    state.structure = structure
  },
  [types.GO_LOCATIONS] (state) {
    state.goLocationsClicked = true
  },
  [types.GO_DURATIONS] (state) {
    state.goDurationsClicked = true
  },
  [types.ON_INPUT_CITIES] (state, payload) {
    if (!payload.cities) {
      state.options.locations.cities = []
    } else {
      state.options.locations.cities = Array.isArray(payload.cities) ? payload.cities : [payload.cities]
    }
    state.hasSelectedLocations = (state.options.locations.countries.length || state.options.locations.cities.length)
  },
  [types.ON_INPUT_COUNTRIES] (state, payload) {
    if (!payload.countries) {
      state.options.locations.countries = []
    } else {
      state.options.locations.countries = payload.countries
    }
    state.hasSelectedLocations = (state.options.locations.countries.length || state.options.locations.cities.length)
  },
  [types.RECEIVED_AUDIENCE] (state, payload) {
    state.summary.audience = payload.audience
  }
}
